<template>
  <a-steps
    class="yy-steps"
    :size="size"
    :current="current"
    label-placement="vertical"
    :items="items"
    :icons="icons"
  >
  </a-steps>
</template>

<script lang="tsx" setup>
import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue'

withDefaults(
  defineProps<{
    current: number
    items: any
    size?: 'default' | 'small'
  }>(),
  {
    size: 'small',
  }
)

const icons = {
  finish: () => <CheckOutlined class="ant-steps-finish-icon" />,
  error: () => <CloseOutlined class="ant-steps-error-icon" />,
}

const antStepIconBg = useCssBgUrl('/youyan-platform/svg/check.svg')
</script>

<style lang="scss">
.yy-steps {
  @apply pt-[40px] pr-[52px];

  .ant-steps-item-finish {
    padding-left: 0 !important;
    .ant-steps-item-icon {
      background: var(--purple-6) !important;
      color: #fff;
      .ant-steps-icon {
        background: v-bind('antStepIconBg') no-repeat center;
        background-size: 75% 75%;
        width: 100%;
        height: 100%;
      }
    }
    .ant-steps-item-description,
    .ant-steps-item-title {
      color: var(--text-1) !important;
    }
    .ant-steps-item-tail {
      &::after {
        opacity: 1;
      }
    }
  }
  .ant-steps-item-container {
    pointer-events: none;
  }

  .ant-steps-item-active {
    .ant-steps-item-icon {
      position: relative;
      background: var(--back-5);
      border: 2px solid var(--purple-6);
      &::before {
        @apply absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 rounded-full;
        content: '';
        display: block;
        width: 9px;
        height: 9px;
        background: var(--purple-6);
      }
    }
    .ant-steps-icon {
      display: none;
    }
  }

  .ant-steps-item-wait {
    .ant-steps-item-icon {
      opacity: 0.3;
      position: relative;
      background: white;
      border: 2px solid var(--purple-6);
    }
    .ant-steps-icon {
      display: none;
    }
  }

  .ant-steps-item-content {
    @apply absolute -top-[40px] text-[14px] left-[45px] flex-y-center gap-[5px];
    display: flex !important;
    align-items: baseline !important;
    width: 200px !important;
    .ant-steps-item-title {
      @apply text-[20px] font-bold;
    }
  }
}
</style>
